import type { FC, ReactNode } from 'react';
import { capitalize } from 'lodash';

interface SidebarProperties {
  readonly date: Date;
  readonly readingTime: string;
  readonly tags?: string[];
  readonly toc?: ReactNode;
}

export const ContentSidebar: FC<SidebarProperties> = ({ date, readingTime, tags, toc: Toc }) => (
  <div className="flex flex-col col-span-4 gap-8 items-start px-6 w-full lg:col-span-2">
    <div className="grid gap-2">
      <p className="text-sm text-muted-foreground">Published</p>
      <p className="text-sm rounded-sm text-foreground">
        {new Intl.DateTimeFormat('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
          timeZone: 'America/New_York',
        }).format(date)}
      </p>
    </div>
    <div className="grid gap-2">
      <p className="text-sm text-muted-foreground">Reading Time</p>
      <p className="text-sm rounded-sm text-muted-base">{readingTime}</p>
    </div>
    {tags ? (
      <div className="grid gap-2">
        <p className="text-sm text-muted-foreground">Tags</p>
        <p className="text-sm rounded-sm text-muted-base">{tags.map((tag) => capitalize(tag)).join(', ')}</p>
      </div>
    ) : null}
    {Toc ? (
      <div className="-mx-2 w-full">
        <div className="grid gap-2 p-2 w-full">
          <p className="text-sm text-muted-foreground">On this page</p>
          {Toc}
        </div>
      </div>
    ) : null}
  </div>
);
